/**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 * Modified by David Little, 2016
 *
 * Rewritten to support multiple calculator instances on the same page
 * (cart drawer + /cart page). Each instance is scoped by its closest
 * .shipping-calculator wrapper; snippets/shipping-calculator.liquid gives
 * every instance its own unique element ids (via the `instance` param),
 * which Shopify.CountryProvinceSelector (from shopify_common.js) needs.
 */

"object" == typeof Countries && (Countries.updateProvinceLabel = function (countryValue, labelEl) {
  if ("string" == typeof countryValue && Countries[countryValue] && Countries[countryValue].provinces) {
    if ("object" != typeof labelEl || !labelEl) return;
    labelEl.innerHTML = Countries[countryValue].label;
  }
});

"undefined" == typeof Shopify.Cart && (Shopify.Cart = {});

Shopify.Cart.ShippingCalculator = function () {
  var _config = {
    submitButton: "Calcular frete",
    submitButtonDisabled: "Calculando...",
    templateId: "shipping-calculator-response-template",
    moneyFormat: "${{amount}}"
  };

  function formatRate(cents) {
    if (typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, _config.moneyFormat);
    }
    return cents;
  }

  function render($scope, data) {
    var $tpl = jQuery("#" + _config.templateId);
    var $wrapper = $scope.find(".wrapper-response");
    if (!$tpl.length || !$wrapper.length) return;
    var compiled = Handlebars.compile(jQuery.trim($tpl.text()));
    $wrapper.empty().append(compiled(data)).show();
  }

  function setLoading($scope, loading) {
    var $btn = $scope.find(".get-rates");
    if (loading) {
      $btn.val(_config.submitButtonDisabled).attr("disabled", "disabled").addClass("disabled");
    } else {
      $btn.val(_config.submitButton).removeAttr("disabled").removeClass("disabled");
    }
  }

  function onError($scope) {
    setLoading($scope, false);
    render($scope, { rates: [], errorFeedback: "Não enviamos para este destino.", success: false });
  }

  function pollRates($scope) {
    (function poll() {
      jQuery.ajax("/cart/async_shipping_rates", {
        dataType: "json",
        success: function (data, status, xhr) {
          if (xhr.status === 200) {
            setLoading($scope, false);
            var rates = data.shipping_rates || [];
            for (var i = 0; i < rates.length; i++) {
              rates[i].price = formatRate(rates[i].price);
            }
            render($scope, { rates: rates, success: true });
          } else {
            setTimeout(poll, 500);
          }
        },
        error: function () { onError($scope); }
      });
    })();
  }

  function requestRates($scope, address) {
    jQuery.ajax({
      type: "POST",
      url: "/cart/prepare_shipping_rates",
      data: jQuery.param({ shipping_address: address }),
      success: function () { pollRates($scope); },
      error: function () { onError($scope); }
    });
  }

  // Keeps a province <label> as "Estado" even after Countries.updateProvinceLabel
  // rewrites it to "State"/"Province"/"Region" on every country change.
  function watchProvinceLabel(labelEl) {
    function fixLabel() {
      var txt = labelEl.textContent.trim();
      if (txt === "State" || txt === "Province" || txt === "Region") {
        labelEl.textContent = "Estado";
      }
    }
    var observer = new MutationObserver(fixLabel);
    observer.observe(labelEl, { childList: true, characterData: true, subtree: true });
    fixLabel();
  }

  function init() {
    jQuery(".shipping-calculator").each(function () {
      var $scope = jQuery(this);
      var $country = $scope.find(".address-country");
      var $province = $scope.find(".address-province");
      var $provinceContainer = $scope.find('[id^="address_province_container_"]');
      var $label = $scope.find('[id^="address_province_label_"]');
      var countryId = $country.attr("id");
      var provinceId = $province.attr("id");

      if (countryId && provinceId) {
        new Shopify.CountryProvinceSelector(countryId, provinceId, {
          hideElement: $provinceContainer.attr("id")
        });

        if (typeof Countries !== "undefined" && $label.length) {
          var labelEl = $label.get(0);
          Countries.updateProvinceLabel($country.val(), labelEl);
          $country.on("change", function () {
            Countries.updateProvinceLabel($country.val(), labelEl);
          });
          watchProvinceLabel(labelEl);
        }
      }

      $scope.find(".get-rates").on("click", function () {
        var zip = $scope.find(".address-zip").val() || "";
        if (!zip) {
          $scope.find(".address-zip").trigger("focus");
          return;
        }
        setLoading($scope, true);
        $scope.find(".wrapper-response").empty().hide();
        var address = {
          zip: zip,
          country: $country.val() || "",
          province: $province.val() || ""
        };
        requestRates($scope, address);
      });
    });
  }

  return {
    show: function (opts) {
      jQuery.extend(_config, opts || {});
      jQuery(init);
    },
    getConfig: function () { return _config; },
    formatRate: formatRate
  };
}();

Shopify.Cart.ShippingCalculator.show({
  submitButton: theme.strings.shippingCalcSubmitButton,
  submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
  moneyFormat: theme.strings.shippingCalcMoneyFormat
});


$('.qtyplus1').on('click', function(e){
  e.preventDefault();
  var currentVal = parseInt($(this).parent().find('input[name="updates[]"]').val());
  if (!isNaN(currentVal)) {
    $(this).parent().find('input[name="updates[]"]').val(currentVal + 1);
  } else {
    $(this).parent().find('input[name="updates[]"]').val(1);
  }
  $( "input[name='update']" ).trigger( "click" );
});

$(".qtyminus1").on('click', function(e) {

  e.preventDefault();
  var currentVal = parseInt($(this).parent().find('input[name="updates[]"]').val());
  if (!isNaN(currentVal) && currentVal > 0) {
    $(this).parent().find('input[name="updates[]"]').val(currentVal - 1);
  } else {
    $(this).parent().find('input[name="updates[]"]').val(1);
  }
  $( "input[name='update']" ).trigger( "click" );
});

function shippingCall(el) {
  var scope = el.closest('.shipping-calculator');
  if (!scope) return;
  var block = scope.querySelector('.shipping-calculator-block');
  if (!block) return;
  block.style.display = (block.style.display === 'none' || !block.style.display) ? 'block' : 'none';
}


$(".cart_heading").on('click', function() {
 if (jQuery(this).hasClass('clicked')) {
   $(this).removeClass('clicked');
  }
  else
  {
   $(this).addClass('clicked');
  }
});


/**
 * "Calcular frete" button on the product page.
 * - If the selected variant is already in the cart: just opens the drawer.
 * - Otherwise: submits the product form (same path as the real "Adicionar ao
 *   carrinho" button, so quantity/variant/etc. are respected), which adds the
 *   item and opens the drawer via the existing ajaxCart.afterCartLoad event.
 * Either way, once the drawer is open, the DRAWER's shipping calculator
 * block is expanded and its CEP field is focused (there may also be a
 * separate calculator instance on the /cart page — this only targets the
 * one inside #CartDrawer).
 */
jQuery(function ($) {
  var $pdpButton = $('.dT_CalcShippingPDP');
  if (!$pdpButton.length) return;

  function expandDrawerCalculator() {
    var scope = document.querySelector('#CartDrawer .shipping-calculator');
    if (!scope) return;
    var block = scope.querySelector('.shipping-calculator-block');
    var zip = scope.querySelector('.address-zip');
    if (block) block.style.display = 'block';
    if (zip) zip.focus();
  }

  $pdpButton.on('click', function (e) {
    e.preventDefault();

    var $form = $('[data-product-form]').first();
    if (!$form.length) return;

    var variantId = $form.find('[name="id"]').val();

    $.getJSON('/cart.js', function (cart) {
      var alreadyInCart = false;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(variantId)) {
          alreadyInCart = true;
          break;
        }
      }

      if (alreadyInCart) {
        if (window.theme && theme.RightDrawer) theme.RightDrawer.open();
        setTimeout(expandDrawerCalculator, 350);
      } else {
        $('body').one('ajaxCart.afterCartLoad', function () {
          setTimeout(expandDrawerCalculator, 350);
        });
        $form.trigger('submit');
      }
    });
  });
});
